"use client"
import React from 'react'
import Navbar from '../../components/admin/common/Navbar'
import MainAdminDocuments from "../../components/admin/documents/MainDocuments"
const AdminDocuments = () => {

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     <MainAdminDocuments/>
    </main>
  </div>
  )
}

export default AdminDocuments
